<div class="h-full">
  <div
    style="
      height: 60px;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 5px;
      cursor: pointer;
    "
    >
    <img src="assets/images/navbar-logo.svg" alt="Idefix title" />
  </div>
  <p-divider [style]="{ width: '90%', margin: 'auto' }"></p-divider>
  <ul class="layout-menu">
    @for (item of model; track $index) {
      <ng-container>
        @if (!item.separator) {
          <li app-menuitem [item]="item" [index]="$index" [root]="true"></li>
        } @else {
          <li class="menu-separator"></li>
        }
      </ng-container>
    }
  </ul>
  @if (env === "dev") {
    <div class="absolute bottom-0 h-4rem w-full flex align-items-center" style="background-color: #3fc370">
      <div class="text-white text-xl inline" style="margin: auto">DEV</div>
    </div>
  } @else if (env === "rec3") {
    <div class="absolute bottom-0 h-4rem w-full flex align-items-center" style="background-color: #60a5fa">
      <div class="text-white text-xl inline" style="margin: auto">REC3</div>
    </div>
  }@else if (env === "rec2") {
      <div class="absolute bottom-0 h-4rem w-full flex align-items-center" style="background-color: #B027F5">
      <div class="text-white text-xl inline" style="margin: auto">STAGING</div>
    </div>
  }@else if (env === "rec1") {
      <div class="absolute bottom-0 h-4rem w-full flex align-items-center" style="background-color: #09C888">
      <div class="text-white text-xl inline" style="margin: auto">REC1</div>
    </div>
  }
</div>
